import Api from "../../config/ApiConfig";
import * as types from "./types";

const apiUrls = {
    triggers: "api/v1/events",
}

export const postEventTriggers = (payload: types.IEventTriggersParams) =>
    Api.post(apiUrls.triggers, payload)
        .then((response) => { return response; })
        .catch((error) => { return error.response; });

export const putEventsTrigger = (param: string, payload: types.IEventsPutReq) =>
    Api.put(apiUrls.triggers + `/${param}`, payload)
        .then((response) => { return response })
        .catch((error) => { return error.response });

export const deleteEventsTrigger = (param: string) =>
    Api.delete(apiUrls.triggers + `/${param}`)
        .then((response) => { return response })
        .catch((error) => { return error.response });